<template>
  <div class="select-date-picker">
    <!-- date picker -->
    <v-date-picker
      v-model="calendarDate"
      :popover="{ placement: 'bottom', visibility: 'click' }"
      @popoverWillShow="onShowCalendar"
      @popoverWillHide="onHideCalendar"
      :disabled="disabled"
    >
      <i-button type="primary" shape="circle" icon="ios-calendar" :disabled="disabled"></i-button>
    </v-date-picker>
  </div>
</template>

<script>
import Vue from 'vue'
// @docs https://vcalendar.netlify.com
import VCalendar from 'v-calendar'
Vue.use(VCalendar, {
  masks: {
    title: 'YYYY年 MM月',
  },
})
import { Button } from 'view-design'

export default {
  components: {
    'i-button': Button,
  },
  data() {
    return {
      calendarDate: null,
    }
  },
  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update:value', val)
      },
    },
  },
  created() {},
  methods: {
    // カレンダー表示処理
    onShowCalendar() {
      this.calendarDate = this.calendarDate = new Date()
    },
    // カレンダー非表示処理
    onHideCalendar() {
      // 未選択の場合は処理無し
      if (!this.calendarDate) return

      // 選択されたカレンダーの日付をフォームの年月日にセット
      const ymd = new Date(this.calendarDate).toLocaleDateString().split('/')
      this._value = `${Number(ymd[0])}/${Number(ymd[1])}/${Number(ymd[2])}`
    },
  },
}
</script>

<style lang="scss" scoped>
.select-date-picker {
  .label {
    margin-right: 8px;
  }
}
</style>
